module.exports = __webpack_public_path__ + "static/media/industries-sand-lime-s.919ac1ec.webp";